import { NavigationPage, TeslaFleetPartnerSheet } from '@/app/components'
import TeslaLogo from '@/authenticated/images/tesla.webp'
import LinkDiagram from '@/app/features/logos/LinkDiagram'
import OptiwattIconLogo from '@/app/img/logo-icon-colored-filled.webp'
import { Button, Icon } from '@/components'
import { AnimatePresence, easeInOut, motion } from 'motion/react'
import VehicleConnectionPitch from '@/app/components/VehicleConnectionPitch/VehicleConnectionPitch'
import { useWhiteLabelData } from '@/hooks/whitelabel/useWhiteLabelData'
import { useTeslaFleetAuthRedirect } from '@/app/hooks/useTeslaFleetAuthRedirect'

export default function ConnectTeslaStartPage() {
  const { whiteLabelData } = useWhiteLabelData()
  const { redirectToTeslaAuth } = useTeslaFleetAuthRedirect('vehicle')

  const logos = [OptiwattIconLogo, TeslaLogo]

  if (whiteLabelData?.largeBrandLogo) {
    logos.unshift(whiteLabelData.largeBrandLogo)
  }

  const missingCapabilitiesParam = new URLSearchParams(
    window.location.search,
  ).get('missing-capabilities')
  const updateCapabilities = missingCapabilitiesParam === 'true'

  const onGetStartedClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    redirectToTeslaAuth()
  }

  return (
    <NavigationPage id="connect-tesla-start-page">
      <NavigationPage.SingleCardContent>
        <div>
          <LinkDiagram widthOverride="tall" logos={logos} />
        </div>
        <div className="flex items-center justify-center w-full mt-4 mb-10">
          <TeslaFleetPartnerSheet />
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            className="h-full"
            key="tesla-connect-prompt"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: easeInOut, duration: 0.15 }}
          >
            <TeslaConnectPrompt
              onGetStartedClick={onGetStartedClick}
              updateCapabilities={updateCapabilities}
            />
          </motion.div>
        </AnimatePresence>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}

function TeslaConnectPrompt({
  onGetStartedClick,
  updateCapabilities,
}: {
  onGetStartedClick: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void
  updateCapabilities: boolean
}) {
  return (
    <>
      <VehicleConnectionPitch make="Tesla" />
      <div className="flex flex-col gap-4 mt-10">
        <Button
          id="tesla-fleet-auth-survey-get-started-button"
          variant="primary"
          onClick={onGetStartedClick}
        >
          <div className="flex items-center gap-2">
            {updateCapabilities
              ? 'Update Tesla Permissions'
              : 'Connect My Tesla Account'}
            <Icon name="ExternalLink" size={18} color="white" />
          </div>
        </Button>
      </div>
    </>
  )
}
